import React from 'react';
import { AppBar, Typography } from '@material-ui/core';

export const HomePageHeader = () => {
  return (
    <div className="footer">
      <AppBar color="inherit">
        <Typography
          variant={window.screen.width < 700 ? 'h6' : 'h4'}
          style={{ margin: window.screen.width < 700 ? 10 : 18 }}
        >
          Spotify Playlist Generator
          <img
            src={process.env.PUBLIC_URL + '/social-media.png'}
            style={{ width: 35, marginLeft: 10, float: 'right' }}
          />
        </Typography>
      </AppBar>
    </div>
  );
};
